import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=39996d56&scoped=true&"
import script from "./LoginForm.vue?vue&type=script&lang=js&"
export * from "./LoginForm.vue?vue&type=script&lang=js&"
import style0 from "./LoginForm.vue?vue&type=style&index=0&id=39996d56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39996d56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39996d56')) {
      api.createRecord('39996d56', component.options)
    } else {
      api.reload('39996d56', component.options)
    }
    module.hot.accept("./LoginForm.vue?vue&type=template&id=39996d56&scoped=true&", function () {
      api.rerender('39996d56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/modules/LoginForm.vue"
export default component.exports